// removed by extract-text-webpack-plugin
module.exports = {"trust":"trust___1K9WX","centered":"centered___1cTO5","images":"images___1lQrU","column-title":"column-title___1gHpp","shop":"shop___1vFgj","column-content":"column-content___181WM","nbc":"nbc___3_Y_r","abc":"abc___3W6gL","today":"today___2qZi0","chicago-tribune":"chicago-tribune___2QjLT","architectural-digest":"architectural-digest___3aRXR","column-content-left":"column-content-left___3zkNb","column-content-right":"column-content-right___3TYtT","separator":"separator___BWYSi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/Trust/Trust.scss
// module id = cq7Z
// module chunks = 57